import { Component, Host, State, h, Element } from '@stencil/core';
import instagram from '../../assets/svg/instagram.svg';
import twitter from '../../assets/svg/twitter.svg';
import facebook from '../../assets/svg/facebook.svg';
import youtube from '../../assets/svg/youtube.svg';
import snapchat from '../../assets/svg/snapchat.svg';
import tiktok from '../../assets/svg/tiktok.svg';

/**
 * @slot social-item - Replaces social item, has replaceable keys `{icon}`, `{type} and {link}`.
 */
@Component({
  tag: 'salla-social',
  styleUrl: 'salla-social.scss',
})
export class SallaSocial {
  constructor() {
    this.socialSlot = this.host.querySelector('[slot="social-item"]')?.innerHTML ||
      `<a href={link} rel="noopener" target="_blank" title={type} aria-label={type}><span class="s-social-icon">{icon}</span></a>`;
    salla.lang.onLoaded(() => {
      this.links = salla.config.get('store.social');
    });
  }

  private readonly socialSlot: string;
  @State() links = salla.config.get('store.social');
  @Element() host: HTMLElement;
  @State() iconsList: any = { instagram, twitter, facebook, youtube, snapchat, tiktok }

  private getLinksArray() {
    return this.links ? Object.entries(this.links)
      .filter(([key, value]) => !!value && key !== 'whatsapp')
      .map(([type, value]) => ({ type, value })) : [];
  }

  componentWillLoad() {
    return new Promise(resolve => salla.onReady(resolve));
  }

  render() {
    const linksArray = this.getLinksArray();
    return (
      <Host>
        <ul class="s-social-list">
          {linksArray.map((link) => (
            <li class="s-social-link">
              <div id="social-slot" innerHTML={this.socialSlot
                .replace(/\{icon\}/g, this.iconsList[link.type])
                .replace(/\{type\}/g, link.type)
                .replace(/\{link\}/g, link.value.toString())}>
              </div>
            </li>
          ))}
        </ul>
      </Host>
    );
  }
  componentDidRender() {
    this.host.querySelectorAll('#social-slot').forEach(el => el.replaceWith(el.firstChild));
    this.host.querySelector('[slot="social-item"]')?.remove();
  }
}
